import { render, staticRenderFns } from "./ThisFooter.vue?vue&type=template&id=ca4b4412&"
import script from "./ThisFooter.vue?vue&type=script&lang=js&"
export * from "./ThisFooter.vue?vue&type=script&lang=js&"
import style0 from "./ThisFooter.vue?vue&type=style&index=0&id=ca4b4412&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports